import * as React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import type { State } from 'types/redux'
import type { DropdownOption } from 'types/ui'
import type { BusinessUser } from 'types/user'
import { loadBusinessUsers } from '@disco/state-management/actions/BusinessUsersActions'
import { updatePlaylistReportParams } from '@disco/state-management/actions/ReportActions'
import UserSelector from 'components/common/user-selector'
type OwnProps = {
  formKey: string
}

function mapStateToProps(state: State, ownProps: OwnProps): any {
  return {
    value: state.reports.playlistReport.form[ownProps.formKey],
    businessUsers: state.entities.businessUsers,
  }
}

function mapDispatchToProps(
  dispatch: ReturnType<typeof import('hooks/use-redux')['useDispatch']>,
  ownProps: OwnProps,
): {
  onChange: (option: DropdownOption) => unknown
  loadBusinessUsers: typeof loadBusinessUsers
} {
  return {
    onChange(option: DropdownOption) {
      const value = option?.value || ''
      dispatch(
        updatePlaylistReportParams({
          [ownProps.formKey]: value,
        }),
      )
    },

    ...bindActionCreators(
      {
        loadBusinessUsers,
      },
      dispatch,
    ),
  }
}

class ReportUser extends React.Component<{
  value: number
  businessUsers: State['entities']['businessUsers']
  placeholder: string
  onChange: (option: DropdownOption) => unknown
  loadBusinessUsers: typeof loadBusinessUsers
  disabled?: boolean
}> {
  componentDidMount() {
    this.props.loadBusinessUsers()
  }

  render() {
    const { placeholder, value, onChange, disabled } = this.props
    const users: BusinessUser[] = Object.values(
      this.props.businessUsers.users,
    ) as BusinessUser[]
    return (
      <UserSelector
        users={users.map(bu => bu.user)}
        placeholder={placeholder}
        multi={false}
        clearable
        usersLoading={false}
        chosenUsers={value}
        onUserSelect={onChange}
        disabled={disabled}
      />
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ReportUser) as any
